<template>
  <div class="expire-page-wrap">
      <div class="title">
         <p v-html="$t('error.page.linkExpired.content')"></p>
      </div>
      <div class="expire-icon"></div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.expire-page-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    padding-top: 100px;
    color: #0096cc;
    text-align: center;
    font-size: 1.9em;
  }

  .expire-icon {
    background: url('~@/assets/image/line-expired.png') no-repeat;
    width: 250px;
    height: 250px;
    background-size: cover;
    margin-top: 45px;
    margin-bottom: 55px;
  }
}
</style>
